import Api from '../api';

import { errorHandler } from '../common';
const { axios: api } = Api;

export const getProductsWithCouriers = () =>
	errorHandler(async () => {
		const data = await api.get(`/lms/get_products_with_couriers`);

		return { data: data.data };
	});

export const getPosts = () =>
	errorHandler(async () => {
		const data = await api.get(`/lms/posts`);

		return { data: data.data };
	});

export const getPickupPoints = (postId, provider) =>
	errorHandler(async () => {
		const data = await api.get(`/lms/pickup-point`, {
			params: {
				postId,
				provider,
			},
		});

		return { data: data.data };
	});
